<!-- eslint-disable vue/multi-word-component-names -->
<!-- Layout filenames are fixed by the house structure spec (Default / Blank / Sidebar /
     Topbar), so the multi-word rule cannot apply to this folder. -->
<template>
    <!-- The window is the frame and only the work scrolls inside it: somebody reading
         forty rows of houses should not have to scroll back up to reach the scope
         selector, which is the control that changes what those rows are. -->
    <div class="flex h-dvh overflow-hidden bg-muted">
        <Sidebar />

        <div class="flex min-w-0 flex-1 flex-col overflow-hidden">
            <Topbar />

            <main class="app-scroll min-w-0 flex-1 overflow-y-auto p-3 sm:p-4 lg:p-6">
                <slot>
                    <RouterView />
                </slot>
            </main>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import Sidebar from '@/layouts/components/Sidebar.vue'
    import Topbar from '@/layouts/components/Topbar.vue'
</script>
